import {IconStyles} from "../../types";
import {colors} from "./scalar";

export const icons: IconStyles = {
  primary: {
    color: colors.primaryBlue,
    label: 'PrimaryIcon'
  },
  secondary: {
    color: colors.grey,
    label: 'SecondaryIcon'
  }
}